const nanoNknToNkn = (nano) => nano * 0.00000001;
export default nanoNknToNkn;
